import type { FormValues } from "../../form";

const isStringFilled = (value: string | null) => (typeof value === "string" ? value.trim().length > 0 : false);

const hasFilledRelationInstance = (instance: { givenName: string; surname: string; secondSurname: string }): boolean =>
    isStringFilled(instance.givenName) || isStringFilled(instance.surname);

const hasFilledEventInstance = (instance: {
    date: { year: number | null; month: number | null; day: number | null };
    location: string;
    gpid: string;
    // Node: We deliberately skip location field
}): boolean => Object.values(instance.date).some((date) => date !== null);

export const getOnlyNameFilled = (values: FormValues): boolean => {
    if (!isStringFilled(values.name.givenName) && !isStringFilled(values.name.surname)) return false;

    const hasFamilyValues = Object.values(values.family).some((relation) =>
        relation.instances.some(hasFilledRelationInstance),
    );
    if (hasFamilyValues) return false;

    const hasEventValues = Object.values(values.events).some((event) => event.instances.some(hasFilledEventInstance));
    if (hasEventValues) return false;

    const hasFieldValues = Object.values(values.fields).some((field) => field.value && isStringFilled(field.value));
    if (hasFieldValues) return false;
    return true;
};
